import { HeadCell } from 'shell/components/shared/table/types';
import { UserProfile } from 'shell/hooks/use-user-profile/types';
import { FamilyVM } from 'shell/view-models/family';

export const headCellsFamilyFunc = ({
  datiLogin,
}: UserProfile): HeadCell<FamilyVM, keyof FamilyVM>[] => {
  const headCellsFamily: HeadCell<FamilyVM, keyof FamilyVM>[] = [
    {
      id: 'fiscalCode',
      label: 'CF',
    },
    {
      id: 'surname',
      label: 'Cognome',
    },
    {
      id: 'name',
      label: 'Nome',
    },
    {
      id: 'gender',
      label: 'Sesso',
    },
    {
      id: 'birthDate',
      label: 'Data nascita',
    },
    {
      id: 'birthPlace',
      label: 'Luogo di nascita',
    },
    ...(datiLogin?.profile?.feature?.visualizzaRapportoParentela === '1'
      ? [
          {
            id: 'relationship',
            label: 'Parentela',
          } as HeadCell<FamilyVM, keyof FamilyVM>,
        ]
      : []),
    {
      id: 'aire',
      label: 'AIRE',
    },
  ];
  return headCellsFamily;
};
